import { DeliveryCampaignProviderService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryCampaignProvider';
import { DeliveryProviderService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProvider';
import { DeliveryProviderNoAuthService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderNoAuth';
import {
  DeliveryProviderPortalService,
  GeneratedApiClient,
  GeneratedApiClientConfig,
  RequestOptionsConstraint,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal';
import { DeliveryProviderPortalNoAuthService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortalNoAuth';
import { LocationSuggestionsDeliveryNoAuthService } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/locationSuggestionsDeliveryNoAuth';

import { HttpClientBoltServerConstraints } from '../types/types';

export class DeliveryProviderPortalApiClient<
  TRequestOptions extends RequestOptionsConstraint,
> extends GeneratedApiClient<
  | DeliveryProviderPortalService.HttpClientConstraints
  | DeliveryProviderPortalNoAuthService.HttpClientConstraints,
  TRequestOptions
> {
  public readonly deliveryCampaignProvider: DeliveryCampaignProviderService.ApiClient<
    DeliveryCampaignProviderService.HttpClientConstraints,
    TRequestOptions
  >;

  public readonly deliveryProvider: DeliveryProviderService.ApiClient<
    DeliveryProviderService.HttpClientConstraints,
    TRequestOptions
  >;

  public readonly deliveryProviderNoAuth: DeliveryProviderNoAuthService.ApiClient<
    DeliveryProviderNoAuthService.HttpClientConstraints,
    TRequestOptions
  >;

  public readonly deliveryProviderPortal: DeliveryProviderPortalService.ApiClient<
    DeliveryProviderPortalService.HttpClientConstraints,
    TRequestOptions
  >;

  public readonly deliveryProviderPortalNoAuth: DeliveryProviderPortalNoAuthService.ApiClient<
    DeliveryProviderPortalNoAuthService.HttpClientConstraints,
    TRequestOptions
  >;

  public readonly locationSuggestionsDeliveryNoAuth: LocationSuggestionsDeliveryNoAuthService.ApiClient<
    LocationSuggestionsDeliveryNoAuthService.HttpClientConstraints,
    TRequestOptions
  >;

  constructor(config: GeneratedApiClientConfig<HttpClientBoltServerConstraints, TRequestOptions>) {
    super(config);
    this.deliveryCampaignProvider = new DeliveryCampaignProviderService.ApiClient(config);
    this.deliveryProvider = new DeliveryProviderService.ApiClient(config);
    this.deliveryProviderNoAuth = new DeliveryProviderNoAuthService.ApiClient(config);
    this.deliveryProviderPortal = new DeliveryProviderPortalService.ApiClient(config);
    this.deliveryProviderPortalNoAuth = new DeliveryProviderPortalNoAuthService.ApiClient(config);
    this.locationSuggestionsDeliveryNoAuth = new LocationSuggestionsDeliveryNoAuthService.ApiClient(
      config,
    );
  }
}
